// Talk to VERA (voice) and Type (a panel beside the page), for any screen. VERA is told which page it is, and the panel
// shows three starts that fit it. The same VERA, tools and memory as everywhere.

import { useState } from "react";
import { Icon, useStudio } from "./ui";
import { RecordsVera } from "./RecordsVera";
import { VoiceMode } from "./VoiceMode";
import { T } from "../lib/i18n";
import type { ScopeId } from "../config/model";

export function AskVera({ heading, where, ideas, onChanged }: { heading: string; where: string; ideas: string[]; onChanged?: () => void }) {
  const { getToken, profile, consent, openConsent, toast } = useStudio();
  const [open, setOpen] = useState(false);
  const [voice, setVoice] = useState(false);
  const scope = (profile.scopes[0] ?? "all") as ScopeId;
  const talk = () => { if (consent.mic) setVoice(true); else { toast(T("Turn on the microphone for voice in Privacy & consent first.")); openConsent(); } };
  return (
    <>
      <button className="btn rec-talk" onClick={talk}><Icon name="mic" size={15} /> {T("Talk to VERA")}</button>
      <button className={`btn sm${open ? " on" : ""}`} onClick={() => setOpen((v) => !v)} aria-pressed={open}><Icon name="chat" size={14} /> {T("Type")}</button>
      {voice && <VoiceMode scope={scope} getToken={getToken} onClose={() => { setVoice(false); onChanged?.(); }} />}
      {open && <RecordsVera owner={false} heading={heading} where={where} ideas={ideas} onChanged={() => onChanged?.()} onClose={() => setOpen(false)} />}
    </>
  );
}
